<template>
  <div class="view-home pb-5">
    <action-dispatcher action="banner/getBanners" class="mb-5">
      <carousel
        :per-page="1"
        :navigation-enabled="true"
        :pagination-enabled="false"
        navigation-next-label="<i class='icon-chevron-right'></i>"
        navigation-prev-label="<i class='icon-chevron-left'></i>"
      >
        <slide v-for="(banner, index) in banners" :key="index">
          <a
            class="banner"
            :href="banner.url"
            :target="
              banner.url.includes('app.seminariodefilosofia.org')
                ? '_self'
                : '_blank'
            "
          >
            <img :src="banner.image" class="w-100" />
          </a>
        </slide>
      </carousel>
    </action-dispatcher>

    <!-- <action-dispatcher action="students/getLastLessons">
      <div class="container">
        <div class="section-title">
          <h2>Continue assistindo</h2>
        </div>

        <div class="row">
          <div
            v-for="(lesson, index) in lastLessons"
            :key="index"
            class="col-lg-3 col-md-6 py-2"
          >
            <lesson-img :lesson="lesson" />
          </div>
        </div>
      </div>
    </action-dispatcher> -->

    <!-- <action-dispatcher
      v-if="$user.cof && $user.cof.id"
      action="courses/getLessons"
      :parameters="{
        id: $user.cof.id,
        params: { limit: 9 }
      }"
    >
      <div class="container">
        <div class="section-title">
          <h2>Assistir ao COF</h2>
        </div>

        <div class="row">
          <div
            v-for="(lesson, index) in listedLessons"
            :key="index"
            class="col-lg-3 col-md-6 py-2"
          >
            <lesson-img :lesson="lesson" />
          </div>
        </div>

        <div class="text-right mt-3">
          <router-link class="btn btn-dark" :to="{ name: 'lessons' }"
            >Veja mais</router-link
          >
        </div>
      </div>
    </action-dispatcher> -->

    <div class="container">
      <div class="section-title">
        <h2>Assistir ao COF</h2>
      </div>

      <div class="row">
        <div class="col-lg-8">
          <div class="embed-responsive embed-responsive-16by9">
            <iframe
              class="embed-responsive-item"
              src="https://www.youtube.com/embed/LsoyMidRZto?rel=0&modestbranding=1&showinfo=0"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div class="col-lg-4 text-secondary">
          <p>
            <b
              >Segundo o próprio, o COF é a peça central de sua filosofia, o
              coração de sua obra.</b
            >
          </p>
          <p>
            Mais de 80.000 alunos acompanharam as aulas ministradas ao vivo pelo
            próprio Olavo, semanalmente. Nessas aulas, o Professor entregou os
            seus mais de 50 anos de estudo, análises e reflexões.
          </p>
          <p>
            Esse conteúdo está à sua disposição somente no Seminário de
            Filosofia, com uma entrega cuidadosamente organizada e não exigirá
            de você um conhecimento prévio de filosofia, literatura, política ou
            qualquer outro assunto abordado no curso.
          </p>
          <p>
            “De você ele só exigirá duas coisas: sinceridade e esforço
            tranquilo.”
          </p>
          <p>— Olavo de Carvalho.</p>
          <a
            class="btn btn-dark"
            href="/cursos/30/curso-online-de-filosofia-edicao-remasterizada"
            >Veja mais</a
          >
        </div>
      </div>
    </div>

    <div class="container mt-5">
      <!-- <div class="section-title">
        <h2>Guias de Estudo</h2>
      </div> -->

      <!-- <action-dispatcher
        action="article/getArticles"
        :parameters="{ limit: 4 }"
      >
        <articles :articles="articles" />
      </action-dispatcher> -->

      <div class="section-title mt-5">
        <h2>Conteúdo aberto</h2>
      </div>

      <action-dispatcher
        action="courses/getFreebies"
        :parameters="{ limit: 4 }"
      >
        <div class="row">
          <div
            v-for="(lesson, index) in freebies"
            :key="index"
            class="col-lg-3 col-md-6 py-2"
          >
            <lesson-img
              :lesson="lesson"
              route="free-lesson"
              :route-params="lesson"
            />
          </div>
        </div>
        <div class="text-right mt-3">
          <router-link class="btn btn-dark" :to="{ name: 'freebies' }"
            >Veja mais</router-link
          >
        </div>
      </action-dispatcher>

      <div class="section-title mt-5">
        <h2>Cursos em destaque</h2>
      </div>

      <action-dispatcher action="courses/getFeatured">
        <swiper
          :breakpoints="{
            0: {
              slidesPerView: 1.1
            },
            576: {
              slidesPerView: 1.5
            },
            768: {
              slidesPerView: 2.5
            },
            992: {
              slidesPerView: 3.5
            }
          }"
          :space-between="30"
          :loop="false"
        >
          <swiper-slide v-for="(course, index) in featured" :key="index">
            <course-card class="h-100" :course="course" />
          </swiper-slide>
        </swiper>
      </action-dispatcher>
    </div>
  </div>
</template>

<script>
import CourseCard from "@/components/courses/CourseCard";
import Articles from "@/components/home/Articles";
import { mapState } from "vuex";
import { Carousel, Slide } from "vue-carousel";
import { Swiper, SwiperSlide } from "swiper-vue2";

import "swiper/swiper-bundle.css";

export default {
  components: { CourseCard, Carousel, Slide, Swiper, SwiperSlide },
  computed: {
    ...mapState("courses", ["featured", "lessons", "freebies"]),
    ...mapState("banner", ["banners"]),
    ...mapState("students", ["lastLessons"]),
    listedLessons() {
      return this.lessons.slice(0, 4);
    }
  }
};
</script>

<style lang="scss" scoped>
.view-home {
  h1 {
    margin-bottom: 0;
  }

  .subtitle {
    font-size: 16px;
    line-height: 24px;
    color: #979797;
    margin-bottom: 52px;
  }

  .section-title {
    display: flex;
    align-items: center;
    margin-bottom: 32px;

    h2 {
      margin-bottom: 0;
    }

    &::after {
      content: "";
      flex-grow: 1;
      height: 1px;
      background-color: #a9a395;
      margin-left: 16px;
    }
  }

  .banner {
    aspect-ratio: 1512 / 418;
    position: relative;
    display: block;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  ::v-deep .VueCarousel-navigation {
    .VueCarousel-navigation-button {
      transform: translateY(-50%) !important;
      color: white !important;
      font-size: 50px;
      text-shadow: 0 0 20px black;
    }
  }

  ::v-deep .swiper-container {
    overflow: visible;
  }
}
</style>
